import React, { useState, useEffect } from "react";
import axios from "axios";
import { Table, Button, Form, Input, Select, Pagination, message } from "antd";
import { EditOutlined, DeleteOutlined } from "@ant-design/icons";
import BASE_URL from '../config';
import moment from "moment";
const { Option } = Select;
const ClassPage = () => {
  const [classes, setClasses] = useState([]);
  const [courses, setCourses] = useState([]);
  const [categories, setCategories] = useState([]);
  const [form] = Form.useForm();
  const [editingClass, setEditingClass] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(5);
  const [searchTerm, setSearchTerm] = useState("");
  const [academicYears, setAcademicYears] = useState([]);
  const [selectedCourse, setSelectedCourse] = useState("");
  // Ref to scroll to top when editing
  const responsiveStyles = {
    formContainer: {
      maxWidth: "600px",
      margin: "auto",
      padding: "10px",
      backgroundColor: "#f9f9f9",
      borderRadius: "10px",
      boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
    },
    inputStyle: {
      width: "100%",
      padding: "8px",
      marginBottom: "10px",
      borderRadius: "5px",
      border: "1px solid #ccc",
    },
    buttonStyle: {
      width: "100%",
      padding: "10px",
      backgroundColor: "#1890ff",
      color: "#fff",
      border: "none",
      borderRadius: "5px",
      cursor: "pointer",
    },
    mobileTable: {
      fontSize: "14px",
      overflowX: "auto",
    },
  };
  useEffect(() => {
    fetchClasses();
    fetchCourses();
    fetchCategories();
  }, []);
  useEffect(() => {
  if (selectedCourse) {
    fetchCategories(selectedCourse);
  } else {
    setCategories([]);
  }
}, [selectedCourse]);
  /* const fetchClasses = async () => {
    try {
      const response = await axios.get(`${BASE_URL}/api/classes`);
      const formattedClasses = response.data.map(cls => ({
        ...cls,
        CreatedDate: cls.CreatedDate
        ? moment(cls.CreatedDate).format("DD-MM-YYYY")
        : "N/A", // Handle null or invalid dates
      }));
      setClasses(formattedClasses);
    } catch (error) {
      console.error("Failed to fetch classes", error);
    }
  }; */
  const fetchClasses = async () => {
  try {
    const response = await axios.get(`${BASE_URL}/api/classes`);

    console.log("Classes API:", response.data); // DEBUG

    if (!Array.isArray(response.data)) {
      console.error("Expected array but got:", response.data);
      setClasses([]); // prevent crash
      return;
    }

    const formattedClasses = response.data.map(cls => ({
      ...cls,
      CreatedDate: cls.CreatedDate
        ? moment(cls.CreatedDate).format("DD-MM-YYYY")
        : "N/A",
    }));

    setClasses(formattedClasses);
  } catch (error) {
    console.error("Failed to fetch classes", error);
    setClasses([]); // safety
  }
};
  /* const fetchCourses = async () => {
    try {
      //const response = await axios.get(`${BASE_URL}/api/courses`);
        const response = await axios.get(`${BASE_URL}/api/coursesa`);
      //setCourses(response.data);
      setCourses(response.data|| []);
    } catch (error) {
      console.error("Failed to fetch courses", error);
    }
  }; */
  const fetchCourses = async () => {
  try {
    const response = await axios.get(`${BASE_URL}/api/coursesa`);

    console.log("COURSES:", response.data); // 👈 IMPORTANT

    if (Array.isArray(response.data)) {
      setCourses(response.data);
    } else {
      console.error("Not array:", response.data);
      setCourses([]);
    }
  } catch (error) {
    console.error("Failed to fetch courses", error);
    setCourses([]);
  }
};
  /* const fetchCategories = async () => {
    try {
      //const response = await axios.get(`${BASE_URL}/api/categories`);
       const response = await axios.get(`${BASE_URL}/api/categoriescl`);
      setCategories(response.data);
    } catch (error) {
      console.error("Failed to fetch categories", error);
    }
  }; */
const fetchCategories = async (courseId) => {
  try {
    const response = await axios.get(
      `${BASE_URL}/api/categoriescl`,
      {
        params: {
          course: courseId,
        },
      }
    );

    setCategories(response.data);
  } catch (error) {
    console.error("Failed to fetch categories", error);
  }
};

  const handleAddOrUpdateClass = async (values) => {
    try {
      const payload = {
        ...values,
         AcademicYearID: editingClass ? values.AcademicYearID : null, // ✅ only for edit
        CreatedBy: sessionStorage.getItem("adminName"),
        CreatedDate: new Date().toISOString().split("T")[0],
      };
      if (editingClass) {
        // Update existing class
        await axios.put(`${BASE_URL}/api/classes/${editingClass.ClassID}`, payload);
        message.success("Class updated successfully!");
      } else {
        // Add new class
        await axios.post(`${BASE_URL}/api/classes`, payload);
        message.success("Class added successfully!");
      }
      fetchClasses();
      form.resetFields();
      setEditingClass(null);
    } catch (error) {
      console.error("Failed to save class", error);
      message.error("Error while saving class");
    }
  };
  const fetchAcademicYears = async (courseId) => {
  try {
    const res = await axios.get(`${BASE_URL}/api/academicYears/${courseId}`);
    setAcademicYears(res.data);
  } catch (error) {
    console.error("Error fetching academic years:", error);
  }
};
  const handleEdit = (record) => {
   /*  console.log(record.CourseID);  // Check if CourseID and CategoryID exist
    console.log(record.CourseName); */
    setEditingClass(record);
    form.setFieldsValue({
      ...record,
     CourseID: record.CourseID,     // ✅ use ID
    CategoryID: record.CategoryID, // ✅ use ID
    AcademicYearID: undefined, // ✅ reset selection
    });
     // ✅ Fetch academic years for selected course
  fetchAcademicYears(record.CourseID);
    // Scroll to the top when editing
    const container = document.querySelector('#root');
    container.scrollTo({ top: 0, behavior: 'smooth' });
  };
  const handleDelete = async (ClassID) => {
    if (!window.confirm("Are you sure you want to delete this Class?")) {
    return;
  }
    try {
      const res = await axios.delete(`${BASE_URL}/api/classes/${ClassID}`);
      //message.success("Class deleted successfully!");
       alert(res.data.message || "Class deleted successfully.");
      fetchClasses();
    } catch (error) {
      console.error("Error deleting Class:", error);

    alert(
      error.response?.data?.message ||
      "Unable to delete Class."
    );
      /* console.error("Failed to delete class", error);
      message.error("Error while deleting class"); */
    }
  };
  const filteredClasses = classes.filter((cls) =>
    cls.ClassName.toLowerCase().includes(searchTerm.toLowerCase())
  );
  const columns = [
    { title: "Class Name", dataIndex: "ClassName", key: "ClassName" },
    { title: "Course", dataIndex: "CourseName", key: "CourseName" },
    { title: "Fee", dataIndex: "Fee", key: "Fee" },
    { title: "Category", dataIndex: "CategoryName", key: "CategoryName" },
    { title: "Created By", dataIndex: "CreatedBy", key: "CreatedBy" },
    { title: "Created Date", dataIndex: "CreatedDate", key: "CreatedDate", render: (date) => (date && moment(date, "DD-MM-YYYY").isValid() ? date : "N/A"), }, // Already formatted in fetchClasses()
    {
      title: "Actions",
      key: "actions",
      render: (_, record) => (
        <>
          <Button
            type="link"
            icon={<EditOutlined />}
            onClick={() => handleEdit(record)}
          />
          <Button
            type="link"
            icon={<DeleteOutlined />}
            danger
            onClick={() => handleDelete(record.ClassID)}
          />
        </>
      ),
    },
  ];
  return (
   <div style={{ maxWidth: "600px", margin: "auto", padding: "10px" }}>
      <h1>Manage Classes</h1>
      {/* Reference for scrolling */}
      <Form form={form} layout="vertical" onFinish={handleAddOrUpdateClass} style={responsiveStyles.formContainer}>
        {editingClass && (
  <Form.Item
    name="AcademicYearID"
    label="Academic Year"
    rules={[{ required: true, message: "Please select Academic Year" }]}
  >
    <Select placeholder="Select Academic Year">
      onChange={(value) => {
    fetchAcademicYears(value); // reload years
    form.setFieldsValue({ AcademicYearID: undefined }); // reset year
  }}
      {academicYears.map((year) => (
        <Select.Option key={year.AcademicYearID} value={year.AcademicYearID}>
          {year.AcademicYearName}
        </Select.Option>
      ))}
    </Select>
  </Form.Item>
)}
        <Form.Item name="ClassName" label="Class Name" rules={[{ required: true, message: "Please enter class name" }]}>
          <Input placeholder="Enter Class Name" />
        </Form.Item>

<Form.Item
  name="CourseID"
  label="Course"
  rules={[{ required: true, message: "Please select a course" }]}
>
  <Select
    placeholder="Select Course"
    onChange={(value) => {
      setSelectedCourse(value);
      fetchCategories(value);
      fetchAcademicYears(value);

      // reset dependent dropdowns
      form.setFieldsValue({
        CategoryID: undefined,
        AcademicYearID: undefined,
      });
    }}
  >
    {Array.isArray(courses) &&
      courses.map((course) => (
        <Option key={course.CourseID} value={course.CourseID}>
          {course.CourseName}
        </Option>
      ))}
  </Select>
</Form.Item>

       {/* <Form.Item name="CourseID" label="Course" rules={[{ required: true, message: "Please select a course" }]}>
          <Select placeholder="Select Course">
             {Array.isArray(courses) &&
            courses.map((course) => (
              <Option key={course.CourseID} value={course.CourseID}>
                {course.CourseName}
              </Option>
            ))}
          </Select>
        </Form.Item>  */}
        {/* Course Select */}
        <Form.Item name="Fee" label="Fee" rules={[{ required: true, message: "Please enter fee" }]}>
          <Input type="number" placeholder="Enter Fee" />
        </Form.Item>
        <Form.Item name="CategoryID" label="Fee Category" rules={[{ required: true, message: "Please select a category" }]}>
          <Select placeholder="Select Fee Category">
            {categories.map((category) => (
              <Option key={category.CategoryID} value={category.CategoryID}>
                {category.CategoryName}
              </Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item>
          <Button type="primary" htmlType="submit">
            {editingClass ? "Update Class" : "Add Class"}
          </Button>
        </Form.Item>
      <Input
        placeholder="Search Classes"
        style={{ marginBottom: "20px" }}
        onChange={(e) => setSearchTerm(e.target.value)}
      />
</Form>
      <Table style={responsiveStyles.mobileTable}
        columns={columns}
        dataSource={filteredClasses.slice((currentPage - 1) * pageSize, currentPage * pageSize)}
        rowKey="ClassID"
        pagination={false}
        scroll={{ x: "max-content" }} // Enables scrolling on smaller screens
      />
      <Pagination
        current={currentPage}
        pageSize={pageSize}
        total={filteredClasses.length}
        onChange={(page, pageSize) => {
          setCurrentPage(page);
          setPageSize(pageSize);
        }}
        style={{ marginTop: "20px" }}
      />
    </div>
  );
};
export default ClassPage;
